import * as z from "zod";

export const setReturnsTiktokIntegrationSettings = {
  name: "setReturnsTiktokIntegrationSettings" as const,
  input: z.object({ isUsingRedoReturnLabels: z.boolean() }),
  output: z.null(),
};
